import { render, staticRenderFns } from "./DataloadPalpations.vue?vue&type=template&id=21918fe1&"
import script from "./DataloadPalpations.vue?vue&type=script&lang=js&"
export * from "./DataloadPalpations.vue?vue&type=script&lang=js&"
import style0 from "./DataloadPalpations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports